import SubscriptionResourceAssignment from 'src/features/subscribers/components/ResourceAssignment/SubscriptionResourceAssignment';
import get from 'lodash/get';
import { getAssignedResources } from 'src/features/resources-assignment/utils';

export const getAssignedResourcesButton = (
    _connectedAppId,
    appRoleInfo,
    _selectedRolesInfo,
    isAdminRole,
    setSelectedRoleInfo,
    hasCorporateStructureEnabled,
    totalRowCountCompany,
    totalRowCountSite,
    toggleResourceSelectionScreenHandler
) => {
    const shouldShowAssignResourcesBtn = hasCorporateStructureEnabled && appRoleInfo.appRoleSelected;
    if (!shouldShowAssignResourcesBtn) {
        return null;
    }
    const selectedResources = get(_selectedRolesInfo, [[appRoleInfo.appRoleId], 'selectedResources'], []);
    const selectAllResources = get(_selectedRolesInfo, [appRoleInfo.appRoleId], []);
    const selectedAllCompany = selectAllResources?.assignAllCompanies;
    const selectedAllSite = selectAllResources?.assignAllSites;
    const assignedResources = getAssignedResources(selectedResources, _connectedAppId, isAdminRole);

    const handleSetResourcesAccess = () => {
        setSelectedRoleInfo(isAdminRole, appRoleInfo.appRoleSelected);
        toggleResourceSelectionScreenHandler({
            activeConnectedAppId: _connectedAppId,
            activeRoleId: appRoleInfo.appRoleId,
            assignedResources,
            selectedAllCompany,
            selectedAllSite,
        });
    };

    const totalResourcesCount = totalRowCountCompany + totalRowCountSite;
    return (
        <SubscriptionResourceAssignment
            handleSetResourcesAccess={handleSetResourcesAccess}
            totalResourcesCount={totalResourcesCount}
        />
    );
};

export const transformResourceKeys = (resources, reverse = false) => {
    if (!resources) {
        return [];
    }
    if (reverse) {
        return resources.map(resource => ({
            resourceDisplayName: resource.name,
            resourceId: resource.id,
            resourceType: resource.type,
        }));
    }
    return resources.map(resource => ({
        name: resource.resourceDisplayName,
        id: resource.resourceId,
        type: resource.resourceType,
    }));
};
